import dfs from './dfs';

var preorder = function preorder(graph, nodes) {
  return dfs(graph, nodes, 'pre');
};

export default preorder;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/graphlib/es/algorithm/preorder.js
// module id = null
// module chunks = 